import { useEffect, useState } from 'react'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import ScrollIndicator from '@/components/ScrollIndicator'
import backgroundImage from '@/assets/images/backgrounds/background.jpg'

export default function Home() {
  const [isVisible, setIsVisible] = useState(false)
  const fullText = 'TAKT CONSTRUCTION SERVICES LTD.'
  const sloganFullText = 'Comprehensive construction solutions delivered with excellence and innovation.'

  useEffect(() => {
    // Trigger fade-in animation after component mounts
    const timer = setTimeout(() => {
      setIsVisible(true)
    }, 100)
    return () => clearTimeout(timer)
  }, [])

  return (
    <>
      {/* Header - Updated 2024 */}
      <Header currentPage="home" />

      {/* Hero Section with Parallax Background */}
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image - Fixed */}
        <div className="fixed inset-0 w-full h-full z-0">
          <img
            src={backgroundImage}
            alt="TAKT Construction Background"
            className="w-full h-full object-cover"
            style={{
              objectFit: 'cover',
              objectPosition: 'center center',
            }}
          />
          <div className="absolute inset-0 bg-black/50" />
        </div>
        
        {/* Hero content */}
        <div className="relative z-20 text-center text-white px-4">
          <div className="max-w-5xl mx-auto">
            <h1 
              className={`text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-6 md:mb-8 leading-tight text-white transition-all duration-1000 ease-out ${
                isVisible 
                  ? 'opacity-100 scale-100' 
                  : 'opacity-0 scale-75'
              }`}
            >
              {fullText}
            </h1>
            <p 
              className={`text-lg md:text-xl lg:text-2xl text-gray-300 max-w-4xl mx-auto leading-relaxed mb-12 transition-all duration-1000 ease-out delay-300 ${
                isVisible 
                  ? 'opacity-100 scale-100' 
                  : 'opacity-0 scale-75'
              }`}
            >
              {sloganFullText}
            </p>
          </div>
        </div>

        {/* Scroll Indicator */}
        <ScrollIndicator targetId="philosophy-section" />
      </section>

      {/* Company Philosophy Section */}
      <section id="philosophy-section" className="py-12 md:py-16 bg-white/80 backdrop-blur-sm relative z-10">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-4 md:mb-6 flex items-center justify-center">
              <div className="w-0.5 h-8 bg-black mr-4"></div>
              BUILDING TRUST, DELIVERING EXCELLENCE
            </h2>
            <p className="text-sm sm:text-base md:text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto px-4">
              At <strong>TAKT Construction Services Ltd.</strong>, we believe that construction is more
              than just building structures. It's about creating trust, collaboration, and delivering
              excellence. Since opening our doors, we've grown steadily, driven by our commitment to
              quality craftsmanship and client-focused care. Over the years, we've delivered a portfolio
              of successful projects that speak to our dedication to integrity and innovation.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </>
  )
} 